// extracted by mini-css-extract-plugin
module.exports = {"blogs":"styles_blogs__mI8fD"};